import { Moment, unitOfTime } from 'moment';
import * as moment from 'moment';

export function changeTimeToEndOfDay(originalDate: Moment): Moment {
  return originalDate.clone().hour(23).minute(59).second(59).millisecond(0);
}

export function changeTimeToStartOfDay(originalDate: Moment): Moment {
  return originalDate.clone().hour(0).minute(0).second(0).millisecond(0);
}

export function getMomentAfterTime(time: string): Moment {
  const periodMatch = /(\d+)(y|m|w)/.exec(time);

  if (periodMatch) {
    return moment().add(
      parseInt(periodMatch[1]),
      periodMatch[2].replace('m', 'M') as unitOfTime.DurationConstructor
    );
  }

  if (/\d{4}-[01]\d-[0-3]\dT?[0-2]\d:[0-5]\d/.test(time)) {
    return moment(time);
  }

  throw new Error('invalid time');
}
